import { NoData } from '../../atoms/Icon/Icon.options';

export const noNetworkDisplay = {
  icon: NoData.NetworkError,
  title: 'Oops! Connection Lost',
  description:
    "Sorry, it seems like we've lost connection. Please check your network and try again",
};
